import ServiceRestApi from "./service-rest-api";

class TeamsService {

    getTeams = () => {
        return ServiceRestApi.get("/api/teams?name");
    }

    addNewTeam = (team) => {
        return ServiceRestApi.post("/api/new-team", team);
    }

    updateTeam = (team) => {
        return ServiceRestApi.post("/api/team", team);
    }

    deleteTeam = (data) => {
        return ServiceRestApi.delete("/api/team?teamId=" + data);
    }
}

export default new TeamsService();